import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateFilter as CreateFilterMutation,
    CreateFilterVariables as CreateFilterMutationVariables,
    FilterCreateInput,
    GetProspectorSavedFilters as GetFiltersQuery,
} from 'nutshell-graphql-types';

import CREATE_FILTER from '../mutations/create-saved-filter.graphql';
import GET_PROSPECTOR_SAVED_FILTERS from '../queries/get-prospector-saved-filters.graphql';

import {PROSPECTOR_TYPE} from './use-get-prospector-saved-filters';

export function useCreateFilter(): {
    createFilter: (arg1: FilterCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [createFilter, {loading, error}] = useMutation<
        CreateFilterMutation,
        CreateFilterMutationVariables
    >(CREATE_FILTER);

    return {
        createFilter: (input: FilterCreateInput) =>
            createFilter({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const cacheResult: GetFiltersQuery | null | undefined = proxy.readQuery({
                        query: GET_PROSPECTOR_SAVED_FILTERS,
                        variables: {
                            type: PROSPECTOR_TYPE,
                        },
                    });

                    const newFilter =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.filterCreate &&
                        mutationResults.data.filterCreate.filter;

                    if (!newFilter) return;

                    if (cacheResult) {
                        proxy.writeQuery({
                            query: GET_PROSPECTOR_SAVED_FILTERS,
                            variables: {
                                type: PROSPECTOR_TYPE,
                            },
                            data: {
                                filters: [...cacheResult.prospectorSavedFilters, newFilter],
                            },
                        });
                    }
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
